import { ActionType } from "./../types/store-types.d";
import { Layout } from "react-grid-layout";
import { IField } from "./../fields/types";
import { IScreenByType } from "./../../hooks/useMedia";
import { IError } from "./../types/errors";
import { IPage } from "./../pages/types";

export interface ILayoutList {
    [key: string]: IDimension;
}

export interface ILayoutState {
    edited: number;
    list: ILayoutList;
}

export interface IUpdateLayoutWithResponsiveData {
    screenByType: IScreenByType;
    fields: IField[];
    id?: IField["_id"];
    [key: string]: any;
}

export interface IAddFieldToLayoutData {
    fieldId: IField["_id"];
    fieldType: IField["type"];
    layout: Layout | null;
}

export interface IReplaceFieldIdInLayoutData {
    tempId: IField["_id"];
    fieldId: IField["_id"];
}

export type ILayoutForBackEnd = {
    field_id: IField["_id"];
    layout_info: IDimension;
};

/* -- Data Types -- */

export interface ISetHeightData {
    id: IField["_id"];
    height: number;
}

export interface IDeleteFieldLayoutData {
    deleteFieldId: IField["_id"];
}

export interface IRefreshLayout {}

export interface IDimension extends Partial<Layout> {}

/* -- Duplicate Layout -- */

export interface IDuplicateFieldToLayoutData {
    pageFieldsIds: IPage["fields"] | undefined;
    fieldId: IField["_id"];
    tempId: IField["_id"];
}

/* -- Update Layout Request Data -- */

export interface IUpdateLayoutRequestData {
    layout?: ILayoutList;
}
export interface IUpdateLayoutSuccessData {}

export interface IUpdateLayoutFailureData extends IError {}

export enum ILayoutActionTypes {
    INIT_LAYOUT = "LAYOUT.INIT_LAYOUT",
    SET_HEIGHT = "LAYOUT.SET_HEIGHT",
    REFRESH_LAYOUT = "LAYOUT.REFRESH",
    UPDATE_LAYOUT_WITH_RESPONSIVE = "LAYOUT.UPDATE_LAYOUT_WITH_RESPONSIVE",
    ADD_FIELD_TO_LAYOUT = "LAYOUT.ADD_FIELD_TO_LAYOUT",
    REPLACE_FIELD_IN_LAYOUT = "LAYOUT.REPLACE_FIELD_IN_LAYOUT",
    DELETE_FIELD_FROM_LAYOUT = "LAYOUT.DELETE_FIELD",

    DUPLICATE_FIELD_TO_LAYOUT = "LAYOUT.DUPLICATE_FIELD_TO_LAYOUT",

    UPDATE_LAYOUT_REQUEST = "LAYOUT.UPDATE_LAYOUT_REQUEST",
    UPDATE_LAYOUT_SUCCESS = "LAYOUT.UPDATE_LAYOUT_SUCCESS",
    UPDATE_LAYOUT_FAILURE = "LAYOUT.UPDATE_LAYOUT_FAILURE",
}

/*-~- Action Types -~-*/

export type ISetLayoutAction = ActionType<ILayoutActionTypes.INIT_LAYOUT, ILayoutList>;

export type ISetHeightAction = ActionType<ILayoutActionTypes.SET_HEIGHT, ISetHeightData>;

export type AddFieldToLayoutActionType = ActionType<ILayoutActionTypes.ADD_FIELD_TO_LAYOUT, IAddFieldToLayoutData>;

export type ReplaceFieldInLayoutActionType = ActionType<
    ILayoutActionTypes.REPLACE_FIELD_IN_LAYOUT,
    IReplaceFieldIdInLayoutData
>;

export type DeleteFieldFromLayoutActionType = ActionType<ILayoutActionTypes.DELETE_FIELD_FROM_LAYOUT, IDeleteFieldLayoutData>;

/* -- Duplicate Layout -- */

export type DuplicateFieldToLayoutActionType = ActionType<
    ILayoutActionTypes.DUPLICATE_FIELD_TO_LAYOUT,
    IDuplicateFieldToLayoutData
>;

/* -- Update Layout Request Actions -- */

export type UpdateLayoutRequestActionType = ActionType<
    ILayoutActionTypes.UPDATE_LAYOUT_REQUEST,
    IUpdateLayoutRequestData
>;

export type UpdateLayoutSuccessActionType = ActionType<
    ILayoutActionTypes.UPDATE_LAYOUT_SUCCESS,
    IUpdateLayoutSuccessData
>;

export type UpdateLayoutFailureActionType = ActionType<
    ILayoutActionTypes.UPDATE_LAYOUT_FAILURE,
    IUpdateLayoutFailureData
>;

export type RefreshLayoutActionType = ActionType<ILayoutActionTypes.REFRESH_LAYOUT, IRefreshLayout>;
